import { ReactQueryCacheProvider, QueryCache } from 'react-query';

import { ReactQueryControllerProps } from './ReactQueryController.types';

const queryCache = new QueryCache();

export const ReactQueryController = ({ children }: ReactQueryControllerProps) => (
  <ReactQueryCacheProvider queryCache={queryCache}>{children}</ReactQueryCacheProvider>
);
